import React, { useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import TeamCoaches from '../../Public/Team/TeamCoaches'
import TeamSquad from '../../Public/Team/TeamSquad'
import AddCoach from '../Player/AddCoach'
import AddPlayer from '../Player/AddPlayer'
import AddPlayerSquad from '../Player/AddPlayerSquad'
import AddLegendStats from './AddLegendStats'
import EditLegendStats from './EditLegendStats'
import EditPlayerSquad from './EditPlayerSquad'
import EditTeamInfo from './EditTeamInfo'

function EditTeam() {
    const { id } = useParams()

    const [activeItem, setActiveItem] = useState('1')

    const squadRef = useRef(null)
    const coachRef = useRef(null)
    const statsRef = useRef(null)
    const legendRef = useRef(null)

    function scrollHandler(activeItem, el) {
        setActiveItem(activeItem)
    }

    return (
        <div>
            <div className="">
                <ul className="nav justify-content-center grey lighten-4 py-4">
                    <li className="nav-item">
                        <div
                            style={{ cursor: 'pointer' }}
                            className={
                                activeItem === '1'
                                    ? 'nav-link text-primary'
                                    : 'nav-link'
                            }
                            onClick={() => scrollHandler('1', 'squad')}
                        >
                            Tropp
                        </div>
                    </li>
                    <li className="nav-item">
                        <div
                            style={{ cursor: 'pointer' }}
                            className={
                                activeItem === '2'
                                    ? 'nav-link text-primary'
                                    : 'nav-link'
                            }
                            onClick={() => scrollHandler('2', 'coach')}
                        >
                            Trenere
                        </div>
                    </li>
                    <li className="nav-item">
                        <div
                            style={{ cursor: 'pointer' }}
                            className={
                                activeItem === '3'
                                    ? 'nav-link text-primary'
                                    : 'nav-link'
                            }
                            onClick={() => scrollHandler('3', 'stats')}
                        >
                            Stats
                        </div>
                    </li>
                    <li className="nav-item">
                        <div
                            style={{ cursor: 'pointer' }}
                            className={
                                activeItem === '4'
                                    ? 'nav-link text-primary'
                                    : 'nav-link'
                            }
                            onClick={() => scrollHandler('4', 'legend')}
                        >
                            Legend
                        </div>
                    </li>
                </ul>
            </div>

            <div className="container">
                {activeItem === '1' && (
                    <>
                        <h2 className="my-4" ref={squadRef}>
                            Tropp
                        </h2>
                        <TeamSquad teamId={id} mode="edit" />

                        <hr />

                        <h2 className="my-4">Legg til spiller i tropp</h2>
                        <AddPlayerSquad teamId={id} />

                        <hr />

                        <h2 className="my-4">Legg til spiller</h2>
                        <AddPlayer />

                        <hr />

                        <h2 className="my-4">Rediger tropp</h2>
                        <EditPlayerSquad teamId={id} />

                        <hr />

                        <h2 className="my-4">Rediger laginfo</h2>
                        <EditTeamInfo teamId={id} />
                    </>
                )}

                {activeItem === '2' && (
                    <>
                        <h2 ref={coachRef} className="my-5">
                            Legg til støtteapparat
                        </h2>
                        <AddCoach teamId={id} />
                        <hr />
                        <TeamCoaches teamId={id} mode="edit" />
                    </>
                )}

                {activeItem === '3' && (
                    <>
                        <h2 ref={statsRef} className="my-5">
                            Legg til spillerstatistikk for lag
                        </h2>
                        <AddLegendStats teamId={id} />
                        <hr />
                        <EditLegendStats teamId={id} limit={100} />
                    </>
                )}

                {activeItem === '4' && (
                    <>
                        <h2 ref={legendRef} className="my-5">
                            Rediger statistikk
                        </h2>
                        <EditLegendStats teamId={id} limit={100} />
                    </>
                )}

                <br />
            </div>
        </div>
    )
}
export default EditTeam
